export { SearchService } from './search-service';
export { MenuService } from './menu-service';
export { LocationService } from './location-service';
export { JobService } from './job-service';
export { ScriptService } from './script-service';
export { BannerService } from './banner-service';
export { LanguageService } from './language-service';
export { WindowRef } from './window-ref';
export { UserService } from './user-service';
export { PageService } from './page-service';
export { CrudService } from './crud-service';
export { CustomerService } from './customer-service';
export { ExpertiseService } from './expertise-service';
export { NetworkService } from './network-service';
export { StrengthService } from './strength-service';
export { OfferService } from './offer-service';
export { ContactUsService } from './contact-us-service';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/services/index.ts